import { render, staticRenderFns } from "./PeekaiNudgeBanner.vue?vue&type=template&id=6c58f8e1&scoped=true"
import script from "./PeekaiNudgeBanner.vue?vue&type=script&lang=js"
export * from "./PeekaiNudgeBanner.vue?vue&type=script&lang=js"
import style0 from "./PeekaiNudgeBanner.vue?vue&type=style&index=0&id=6c58f8e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c58f8e1",
  null
  
)

export default component.exports